import React from "react";
import "./App.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TalkPage from "./pages/TalkPage";

function App() {
  return (
    <div className="App" style={{ fontFamily: "'Inter', sans-serif" }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TalkPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
